import React, { useEffect, useState } from 'react';
import { Grid, makeStyles, Typography } from '@material-ui/core';
import { postAssignRole } from '../../../../Utils/apiServices';
import { useTranslation } from 'react-i18next';
import context from '../../../../Utils/context';
import { KEY_ACADEMIC_ROLES } from '../../../../Utils/themes/constant';
import RoleActionButtons from './roleActionButtons';
import SelectGrades from '../../../../Components/SelectGrades/index';
import SelectSections from '../../../../Components/SelectSections';
import SelectProgramPlan from '../../../../Components/SelectProgramPlan';

const useStyles = makeStyles((theme) => ({
  selectGrade: {
    fontSize: 13,
    padding: '12px 15px',
    border: `1px solid ${theme.palette.KenColors.neutral40}`,
    color: theme.palette.KenColors.neutral400,
    background: theme.palette.KenColors.neutral10,
  },
  gradeContainer: {
    marginTop: 12,
  },
  selectGradeCheck: {
    border: `1px solid ${theme.palette.KenColors.neutral40}`,
    padding: '0px 15px',
  },
  selectGradeLabel: {
    fontSize: 13,
    color: theme.palette.KenColors.neutral400,
  },
  subHeading: {
    fontSize: 13,
    fontWeight: 'bold',
    color: theme.palette.KenColors.neutral400,
    marginBottom: 8,
  },
  roles: {
    fontSize: 12,
    color: theme.palette.KenColors.neutral400,
  },
}));

export default function FacultyRole(props) {
  const { role, setLoader, contactInfo, selectedInstitute } = props;
  const classes = useStyles();
  const { t } = useTranslation();
  const [sections, setSections] = React.useState([]);
  const [departments, setDepartments] = React.useState([]);
  const [selectedDepartments, setSelectedDepartments] = React.useState([]);
  const [selectedProgramPlan, setSelectedProgramPlan] = React.useState();
  const [selectedGrades, setSelectedGrades] = React.useState([]);
  const { handleSnackbarOpen } = React.useContext(context);
  const [selectedData, setSelectedData] = useState([]);
  const [programId, setProgramId] = useState();

  useEffect(() => {
    setSections([]);
    setSelectedGrades([]);
    setDepartments([]);
    setSelectedProgramPlan();
    setSelectedData([]);
    setSelectedDepartments([]);
  }, [role, selectedInstitute]);

  const handleSections = (event, newSection, id, progId) => {
    setSections((sect) => ({
      ...sect,
      [id]: newSection,
    }));
    setProgramId((pId) => ({
      ...pId,
      [id]: progId,
    }));
  };

  useEffect(() => {
    const arr = [];
    selectedGrades?.map((el) => {
      const name = departments.find((item) => item.value === el).label;
      arr.push({
        name: name,
        selectedClasses: sections[el],
        programId: programId[el],
        academicProgram: el,
      });
    });
    setSelectedData([...arr]);
  }, [sections]);

  const handleDepartment = (e, grad) => {
    const selectedGradesValueArr = e.target.value;
    setSelectedGrades(selectedGradesValueArr);
    const arr = [];
    selectedGradesValueArr?.map((el) => {
      const name = grad.find((item) => item.value === el).label;
      arr.push({ id: el, name: name });
      setSelectedProgramPlan((pId) => ({
        ...pId,
        [el]: '',
      }));
    });
    setDepartments(grad);
    setSelectedDepartments([...arr]);

    let selectedDataArr = [];
    if (selectedData.length > 0) {
      selectedData?.map((el) => {
        if (selectedGradesValueArr.includes(el?.academicProgram)) {
          selectedDataArr.push(el);
        }
      });
      setSelectedData([...selectedDataArr]);
    }
  };

  const handleCancel = () => {
    setSections([]);
    setSelectedGrades([]);
    setDepartments([]);
    setSelectedProgramPlan();
    setSelectedData([]);
    setSelectedDepartments([]);
  };

  const onChangeProgramPlan = (e, id) => {
    const programId = e.target.value;
    setSelectedProgramPlan((pId) => ({
      ...pId,
      [id]: programId,
    }));
  };

  const handleAssign = () => {
    setLoader(true);
    const arr = [];
    selectedData?.map((el) => {
      el?.selectedClasses?.map((elem) => {
        arr.push({
          roleId: '0',
          Contact__c: contactInfo?.Id,
          Program_Plan__c: el.programId,
          Section_ID__c: elem,
          Roles__c: role,
          Account__c: el.academicProgram,
        });
      });
    });

    if (arr.length > 0) {
      postAssignRole({ roles: [...arr] })
        .then((res) => {
          handleSnackbarOpen('success', t('messages:Roles_has_been_created'));
          setLoader(false);
        })
        .catch((err) => {
          console.log(err);
          setLoader(false);
          handleSnackbarOpen(
            'warning',
            t('messages:Errors_creating_the_Roles')
          );
        });
    } else {
      handleSnackbarOpen('warning', t('messages:Please_select_section'));
      setLoader(false);
    }
  };

  return (
    <Grid>
      {role === KEY_ACADEMIC_ROLES.ClassTeacher && (
        <Grid container className={classes.gradeContainer}>
          <Grid container>
            <SelectGrades
              setLoader={setLoader}
              selectedGrades={selectedGrades}
              onChange={handleDepartment}
              id={selectedInstitute}
            />
          </Grid>
        </Grid>
      )}

      {selectedDepartments &&
        selectedDepartments?.map((el) => {
          return (
            <div>
              {role === KEY_ACADEMIC_ROLES.ClassTeacher && (
                <Grid container className={classes.gradeContainer}>
                  <Typography className={classes.subHeading}>
                    {t('labels:Select_Class_Section')} - {el?.name}
                  </Typography>
                  <SelectProgramPlan
                    setLoader={setLoader}
                    id={el?.id}
                    value={selectedProgramPlan[el?.id]}
                    onChange={onChangeProgramPlan}
                  />
                </Grid>
              )}

              {role === KEY_ACADEMIC_ROLES.ClassTeacher &&
                selectedProgramPlan[el.id] !== '' && (
                  <Grid container className={classes.gradeContainer}>
                    <Grid item md={12}>
                      <Typography className={classes.roles}>
                        {t('labels:Select_Grade_Section')}
                      </Typography>
                    </Grid>
                    <SelectSections
                      value={sections[el.id]}
                      onChange={handleSections}
                      id={el.id}
                      programId={selectedProgramPlan[el.id]}
                      setLoader={setLoader}
                    />
                  </Grid>
                )}
            </div>
          );
        })}

      <Grid item md={12} style={{ marginTop: 16, textAlign: 'end' }}>
        {selectedData.length > 0 && (
          <RoleActionButtons
            handleAssign={handleAssign}
            handleCancel={handleCancel}
          />
        )}
      </Grid>
    </Grid>
  );
}
